import { render, staticRenderFns } from "./RdsFooter.vue?vue&type=template&id=5987c388&scoped=true&"
import script from "./RdsFooter.vue?vue&type=script&lang=js&"
export * from "./RdsFooter.vue?vue&type=script&lang=js&"
import style0 from "./RdsFooter.vue?vue&type=style&index=0&id=5987c388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987c388",
  null
  
)

export default component.exports